import './index.css';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { queryClient } from './queries/queryClient';
import { router } from './router';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AppLoader } from './components/AppLoader';
import { HelmetProvider } from 'react-helmet-async';
import { RollbarProvider } from 'providers/RollbarProvider';

const rootElement = document.getElementById('root');
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <RollbarProvider>
        <HelmetProvider>
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} fallbackElement={<AppLoader />} />
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </HelmetProvider>
      </RollbarProvider>
    </StrictMode>
  );
}
